import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as typesAccount from '@account/store/types'
import { Base64 } from 'js-base64';
import {mapGetters} from "vuex";

@Component({
    computed: {
        ...mapGetters({
            user: typesAccount.USER,

        }),
    },
})
export default class Home extends Vue {
    user!: account.User;

   created() {
        if (this.isPopupWindow()) {
            return;
        }
        // 팀즈 제외
        if(!this.isTeams){
            //이노엔 회사코드로 분기 처리 필요
            var agent = navigator.userAgent.toLowerCase();
            var bfssoexcast = false;

            if ( agent.indexOf('trident') > -1 || (agent.indexOf("msie") > -1) ) {

                try{
                    var axObj = null;
                    axObj = new ActiveXObject("F_NewSSO.NewSSO.1");
                    if(axObj)
                    {
                        bfssoexcast = true;
                    }
                } catch(e) { }
            }else{
                bfssoexcast = true;
            }


            // DRM 제외 사용자 PersonCode
            var personCodes = ['COM_02_feelanet01',  'COM_02_feelanet02','COM_02_feelanet03','COM_02_feelanet04','COM_02_feelanet05'
                ,'COM_01_feelanet06','COM_01_feelanet07','COM_01_feelanet08','COM_01_InformationStrategy']


            if(bfssoexcast &&  this.user &&
                (this.user.comCode == 'COM22' || this.user.comCode == 'COM17' || this.user.comCode == 'COM_02' || this.user.comCode == 'COM_01')
                && !personCodes.includes(this.user.personCode)){
                this.SetUserInfoUriScheme();
            }

        }
   }

    SetUserInfoUriScheme(){
         var userid = this.user.personId;

         var msg = "status@@EQUAL@@LOGIN@@DELIM@@id@@EQUAL@@"+userid+"@@DELIM@@pwd@@EQUAL@@1111@@DELIM@@clsid@@EQUAL@@{1CEB70FD-234E-40BD-A5CC-CFF6ACCAC133}@@DELIM@@dsdcode@@EQUAL@@0100000000001597";

         // Base64로 인코딩한 후, URL 인코딩 처리
         const encodedMsg = encodeURI(Base64.encode(msg));

         // location.href에 URI로 인코딩된 Base64 메시지를 전달4
         location.href = "fssoexcast://setuserinfo?msg=" + encodedMsg;

    }
    
    isPopupWindow() {
        return !!window.opener || window.name === 'popup';
    }
}
